export const FETCH_HW_VARIANTS = 'FETCH_HW_VARIANTS';

export const fetchHwVariants = () => {
    return {
        type: FETCH_HW_VARIANTS,
    };
};
